import React from "react";

const RadniNalogZaStampu = ({ podaci }) => {
  const {
    Logo = "",
    PIB = "",
    MB = "",
    NazivFirme = "",
    SifraDelatnosti = "",
    PDVbroj = "",
    NalogZaUtovar = "",
    Vozilo = "",
    Vozac = "",
    Utovari = [],
    Istovari = [],
    CarinjenjeIGranica = [],
  } = podaci ?? {};

  // URL helper
  const getFileUrl = (path) => {
    if (!path) return null;
    if (/^https?:\/\//i.test(path)) return path;
    let normalized = String(path).replace(/\\/g, "/");
    normalized = normalized.replace(/^C:\/Dokumenta\//i, "");
    normalized = normalized.replace(/^\/+/, "");
    return `${process.env.REACT_APP_BACKEND_URL}/files/${encodeURI(normalized)}`;
  };
  const logoUrl = getFileUrl(Logo);

  const printStyles = `
  *{box-sizing:border-box}
  html,body{margin:0;padding:0;font-family:Arial, sans-serif;font-size:10.5pt;color:#000}
  @page{size:A4 portrait;margin:0.75in 0.7in}
  #rutni-page{page:auto;position:relative;min-height:100vh}
  .wrap{white-space:normal!important;word-break:break-word;overflow-wrap:anywhere;line-height:1.25}

  /* Header */
  .header{position:relative}
  .logo-box{max-width:45%}
  .logo-box img{width:auto;height:auto;object-fit:contain}

  .company-info{position:absolute;top:0;right:0;text-align:left}
  .company-info .row{font-size:10pt}
  .company-info .label{font-weight:600;margin-right:6px}

  .breakLine { width: 100%; margin: 8pt 0; }
    .breakLineSvg { display: block; width: 100%; }
  /* Meta */
  .meta{display:flex;justify-content:space-between;align-items:center;margin-top:10px}
  .box{border:1px solid #000;padding:10px;max-width:fit-content;background-color:#b3b3b3}
  .meta-left .label{font-weight:600;margin-right:6px}
  .meta-right {
  display:flex; flex-direction: column; justify-content: flex-start;}
  .meta-right .item{display:flex; justify-content: space-between;align-items: center}
  .meta-right .item .label{font-weight:600;margin-bottom:2px}
  .item .wrap {margin: 0 10px 0 10px;}
  /* Sekcije */
  .section-title{font-size:20pt}
  .headerUtovarIstovar{
    margin:10px 0;height:50px;display:flex;justify-content:center;align-items:center;
    border:1px solid #000;background:#b3b3b3
  }
  .marginTopBottom{margin:10px 0}
  .numberLoadUnload{background:#b3b3b3;width:fit-content;border:1px solid #000;padding:5px 10px;display:flex;align-items:center}

  /* Dvokolonski layout LABEL | VALUE */
  .kv-grid{display:grid;grid-template-columns:38% 62%;border:none}
  .kv-grid .row{display:contents}
  .kv-grid .cell{padding:6px 8px}
  .kv-grid .label{font-weight:600;border:none;background:#fff}
  /* SAMO VALUE ima border */
  .kv-grid .value{background:#fff;border:1px solid #000;min-height:22px}

  .footer{position:fixed;left:0;right:0;bottom:0;padding:8px 0}
  .footer-inner{margin:0 auto;width:fit-content;border:1px solid #000;padding:6px 14px;font-weight:600}

  .content{padding-bottom:2.4cm}
  .card,.kv-grid{page-break-inside:avoid}
  .rowLabel {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-right: 20px;
  }

  @media print{
  .screen-only{display:none!important}
     * {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  /* Umesto background u printu — ubaci “inset fill” */
  .box,
  .headerUtovarIstovar,
  .numberLoadUnload {
    background: none !important;                     /* skini background */
    box-shadow: inset 0 0 0 1000px #b3b3b3 !important;/* ispunjeno sivo */
  }
    }
  `;

  const nbspIfEmpty = (v) =>
    v === 0 ? "0" : (v === null || v === undefined || v === "") ? "\u00A0" : v;

  const BreakLine = ({ heightPt = 1.2, dotPx = 1, gapPx = 3 }) => (
  <div className="breakLine">
    <svg
      className="breakLineSvg"
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height={`${heightPt}pt`}
      viewBox="0 0 100 ${heightPt}"
      preserveAspectRatio="none"
      aria-hidden="true"
    >
      <defs>
        {/* Šablon “tačkica” koji se ponavlja po X osi */}
        <pattern id="dotPattern" patternUnits="userSpaceOnUse" width={dotPx + gapPx} height="2">
          <circle cx={dotPx / 2} cy="1" r={dotPx / 2} fill="#000" />
        </pattern>
      </defs>
      {/* Pravougaonik ispunjen šablonom (ponavljanje po širini) */}
      <rect x="0" y="0" width="100%" height="100%" fill="url(#dotPattern)" />
    </svg>
  </div>
);
  // Fiksni set polja za UTOVAR
  const UTOVAR_FIELDS = [
    { key: "datumUtovara", label: "Datum utovara:" },
    { key: "nazivPreduzeca", label: "Naziv preduzeća:" },
    {
      key: "adresa",
      label: "Adresa:",
      render: (u) =>
        nbspIfEmpty(
          [u.adresa, u.postanskiBroj, u.grad, u.drzava].filter(Boolean).join(", ")
        ),
    },
    { key: "vrstaRobe", label: "Vrsta robe:" },
    { key: "referentniBroj", label: "Ref. broj:" },
    { key: "brojPaleta", label: "Broj paleta:" },
    { key: "tezinaRobe", label: "Težina robe (kg):" },
    { key: "temperaturniRezim", label: "Temperaturni režim:" },
    {
      key: "vrednostRobe",
      label: "Vrednost robe:",
      render: (u) =>
        u?.vrednostRobe
          ? `${u.vrednostRobe} ${u.vrednostRobeValuta || ""}`
          : "\u00A0",
    },
    { key: "napomena", label: "Napomena:" },
  ];

  // Fiksni set polja za ISTOVAR (ako želiš iste kao UTOVAR, samo koristi UTOVAR_FIELDS)
  const ISTOVAR_FIELDS = [
    { key: "datumIstovara", label: "Datum istovara:" },
    { key: "nazivPreduzeca", label: "Naziv preduzeća:" },
    {
      key: "adresa",
      label: "Adresa:",
      render: (i) =>
        nbspIfEmpty(
          [i.adresa, i.postanskiBroj, i.grad, i.drzava].filter(Boolean).join(", ")
        ),
    },
    { key: "vrstaRobe", label: "Vrsta robe:" },
    { key: "referentniBroj", label: "Ref. broj:" },
    { key: "brojPaleta", label: "Broj paleta:" },
    { key: "tezinaRobe", label: "Težina robe (kg):" },
    { key: "napomena", label: "Napomena:" },
  ];

  const CARINJENJE_FIELDS = [
    { key: "Izvozno carinjenje", label: "Izvozno carinjenje:" },
    { key: "Naziv špeditera izvoz", label: "Naziv špeditera izvoz:" },
    { key: "Granični prelaz", label: "Granični prelaz:" },
    { key: "Naziv špeditera na granici", label: "Naziv špeditera na granici:" },
    { key: "Napomena granica", label: "Napomena granica:" },
    { key: "Uvozno carinjenje", label: "Uvozno carinjenje:" },
    { key: "Naziv špeditera uvoz", label: "Naziv špeditera uvoz:" },
  ];

  const renderFixedRows = (item, fields) => (
    <div className="kv-grid marginTopBottom">
      {fields.map((f, idx) => {
        const val =
          typeof f.render === "function"
            ? f.render(item)
            : nbspIfEmpty(item?.[f.key]);
        return (
          <div className="row" key={`${f.key}-${idx}`}>
            <div className="cell label rowLabel">{f.label}</div>
            <div className="cell value wrap">{val}</div>
          </div>
        );
      })}
    </div>
  );

  return (
    <div id="rutni-page">
      <style>{printStyles}</style>

      {/* HEADER */}
      <div className="header">
        <div className="logo-box">{logoUrl ? <img src={logoUrl} alt="Logo" /> : null}</div>
      </div>

      <div className="company-info">
        {PIB && (
          <div className="row">
            <span className="label">PIB:</span>
            <span>{PIB}</span>
          </div>
        )}
        {MB && (
          <div className="row">
            <span className="label">MB:</span>
            <span>{MB}</span>
          </div>
        )}
        {SifraDelatnosti && (
          <div className="row">
            <span className="label">Šifra delatnosti:</span>
            <span>{SifraDelatnosti}</span>
          </div>
        )}
        {PDVbroj && (
          <div className="row">
            <span className="label">PDV broj:</span>
            <span>{PDVbroj}</span>
          </div>
        )}
      </div>

      {/* META */}
      <div className="meta">
        <div className="box meta-left">
          <span className="label">Nalog za utovar (radni nalog):</span>
          <span className="wrap">{nbspIfEmpty(NalogZaUtovar)}</span>
        </div>
        <div className="meta-right">
          <div className="item">
            <span className="box label">Vozilo:</span>
            <span className="wrap">{nbspIfEmpty(Vozilo)}</span>
          </div>
          <div className="item" style={{ marginTop: 6 }}>
            <span className="box label">Vozač:</span>
            <span className="wrap">{nbspIfEmpty(Vozac)}</span>
          </div>
        </div>
      </div>

      <div className="content">
        {/* UTOVARI */}
        <div className="headerUtovarIstovar">
          <h3 className="section-title">Utovari</h3>
        </div>

        {Utovari?.length ? (
          Utovari.map((u, idx) => (
            <>
            <div key={`utovar-${idx}`}>
              <div className="numberLoadUnload">
                <p style={{ margin: 0 }}>{idx + 1}.</p>
              </div>
              {renderFixedRows(u, UTOVAR_FIELDS)}
            </div>
            <BreakLine />
            </>
          ))
        ) : (
          <>
            <div className="numberLoadUnload">
              <p style={{ margin: 0 }}>1.</p>
            </div>
            {renderFixedRows({}, UTOVAR_FIELDS)}
             <BreakLine />
          </>
        )}

        <div className="hr" />
          {/* Carinjenje */}
        <div className="headerUtovarIstovar">
          <h3 className="section-title">Carinjenje (uvoz/izvoz), granica</h3>
        </div>

        {CarinjenjeIGranica?.length ? (
          CarinjenjeIGranica.map((u, idx) => (
            <>
            <div key={`carinjenje-${idx}`}>
              {renderFixedRows(u, CARINJENJE_FIELDS)}
            </div>
            <BreakLine />
            </>
          ))
        ) : (
          <>
            {renderFixedRows({}, CARINJENJE_FIELDS)}
             <BreakLine />
          </>
        )}

        <div className="hr" />

        {/* ISTOVARI */}
        <div className="headerUtovarIstovar">
          <h3 className="section-title">Istovari</h3>
        </div>

        {Istovari?.length ? (
          Istovari.map((i, idx) => (
            <>
            <div key={`istovar-${idx}`}>
              <div className="numberLoadUnload">
                <p style={{ margin: 0 }}>{idx + 1}.</p>
              </div>
              {renderFixedRows(i, ISTOVAR_FIELDS)}
            </div>
             <BreakLine />
             </>
          ))
        ) : (
          <>
            <div className="numberLoadUnload">
              <p style={{ margin: 0 }}>1.</p>
            </div>
            {renderFixedRows({}, ISTOVAR_FIELDS)}
            <BreakLine />
          </>
        )}
      </div>

      {/* FOOTER – na svakoj stranici */}
      <div className="footer" aria-hidden="true">
        <div className="footer-inner">
          {NazivFirme ? `${NazivFirme} - Srećan put !` : "Srećan put !"}
        </div>
      </div>
    </div>
  );
};

export default RadniNalogZaStampu;
